import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../api/client";

export default function AdminDashboard() {
  const navigate = useNavigate();
  const [data, setData] = useState<any>(null);
  const [blocked, setBlocked] = useState<any>(null);
  const [showBlocked, setShowBlocked] = useState(false);
  const [proxy, setProxy] = useState<any>(null);
  const [speed, setSpeed] = useState<any>(null);
  const [pay, setPay] = useState<any>(null);

  useEffect(() => {
    api.get("/admin/dashboard").then((r: any) => setData(r.data));
    api.get("/admin/blocked-users").then((r: any) => setBlocked(r.data)).catch(() => {});
    api.get("/admin/proxy").then((r: any) => setProxy(r.data)).catch(() => {});
    api.get("/admin/speed?days=1").then((r: any) => setSpeed(r.data)).catch(() => {});
    api.get("/admin/payments-summary").then((r: any) => setPay(r.data)).catch(() => {});
  }, []);

  if (!data) {
    return (
      <div style={styles.center}>
        <div style={styles.spinner} />
      </div>
    );
  }

  const s = data.stats;

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Админ-панель</h1>

      <div style={styles.tabs}>
        <button style={{ ...styles.tabBtn, ...styles.tabBtnActive }}>Статистика</button>
        <button style={styles.tabBtn} onClick={() => navigate('/admin/broadcasts')}>Рассылки</button>
      </div>

      <div style={styles.grid}>
        <Card title={pay ? `Оплат: ${pay.all.count} · сегодня: ${pay.today.count} ›` : "Платежи ›"} value={pay ? `${Math.round(pay.all.sum).toLocaleString("ru-RU")} ₽` : "—"} onClick={() => navigate('/admin/payments')} />
        <Card title="Пользователей ›" value={s.total_users} onClick={() => navigate('/admin/growth')} />
        <Card title="Активных поисков ›" value={s.active_searches} onClick={() => navigate('/admin/active-searches')} />
        <Card title="Заблокировали бота ▾" value={blocked ? blocked.count : "—"} onClick={() => setShowBlocked(!showBlocked)} />
        <Card title="Прокси, осталось ›" value={proxy?.summary?.total ? `${(proxy.summary.remaining / 1073741824).toFixed(2)} ГБ` : "—"} onClick={() => navigate('/admin/proxy')} />
        <Card title="Скорость доставки, сегодня ›" value={speed?.total?.median != null ? `≈ ${String(speed.total.median).replace('.', ',')} мин` : "—"} onClick={() => navigate('/admin/speed')} />
      </div>
      {showBlocked && blocked && (
        <div style={{ ...styles.list, marginTop: "12px" }}>
          {blocked.items.length === 0 ? (
            <div style={styles.rowHint}>Пока никто</div>
          ) : (
            blocked.items.map((u: any) => (
              <div key={u.telegram_id} style={styles.row}>
                <div>
                  <div style={styles.rowTitle}>
                    {u.username ? (
                      <a href={`https://t.me/${u.username}`} target="_blank" rel="noopener noreferrer"
                         style={{ color: "inherit", textDecoration: "none" }}>@{u.username}</a>
                    ) : (u.first_name || `TG: ${u.telegram_id}`)}
                  </div>
                  <div style={styles.rowHint}>{u.blocked_at} МСК</div>
                </div>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}

function Card({ title, value, onClick }: { title: string; value: number | string; onClick?: () => void }) {
  return (
    <div style={{ ...styles.card, cursor: onClick ? "pointer" : "default" }} onClick={onClick}>
      <div style={styles.cardValue}>{value}</div>
      <div style={styles.cardTitle}>{title}</div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  showAllBtn: {
    background: "none",
    border: "none",
    color: "var(--tg-theme-link-color, #2481cc)",
    fontSize: "13px",
    cursor: "pointer",
  },
  statusBadge: {
    display: "inline-block",
    marginTop: "4px",
    fontSize: "11px",
    color: "#fff",
    padding: "2px 8px",
    borderRadius: "10px",
  },
  container: { padding: '16px', maxWidth: '480px', margin: '0 auto' },
  tabs: { display: 'flex', gap: '8px', marginBottom: '16px' },
  tabBtn: { flex: 1, padding: '8px', borderRadius: '10px', border: 'none', backgroundColor: 'var(--tg-theme-secondary-bg-color, #fff)', color: 'var(--tg-theme-text-color, #000)', fontSize: '13px', cursor: 'pointer' },
  tabBtnActive: { backgroundColor: 'var(--tg-theme-button-color, #2481cc)', color: 'var(--tg-theme-button-text-color, #fff)' },
  center: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' },
  spinner: { width: '32px', height: '32px', border: '3px solid #e5e7eb', borderTop: '3px solid #3b82f6', borderRadius: '50%', animation: 'spin 1s linear infinite' },
  title: { fontSize: '22px', fontWeight: 700, margin: '0 0 16px 0', color: 'var(--tg-theme-text-color, #000)' },
  subtitle: { fontSize: '16px', fontWeight: 600, margin: '20px 0 10px 0', color: 'var(--tg-theme-text-color, #000)' },
  grid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' },
  card: { backgroundColor: 'var(--tg-theme-secondary-bg-color, #fff)', borderRadius: '16px', padding: '16px', textAlign: 'center', boxShadow: '0 1px 3px rgba(0,0,0,0.08)' },
  cardValue: { fontSize: '24px', fontWeight: 700, color: 'var(--tg-theme-text-color, #000)' },
  cardTitle: { fontSize: '12px', color: 'var(--tg-theme-hint-color, #666)', marginTop: '4px' },
  list: { display: 'flex', flexDirection: 'column', gap: '8px' },
  row: { backgroundColor: 'var(--tg-theme-secondary-bg-color, #fff)', borderRadius: '12px', padding: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  rowTitle: { fontSize: '14px', fontWeight: 600, color: 'var(--tg-theme-text-color, #000)' },
  rowHint: { fontSize: '12px', color: 'var(--tg-theme-hint-color, #666)' },
  rowAmount: { fontSize: '15px', fontWeight: 700, color: 'var(--tg-theme-text-color, #000)' },
};
